<template>
  <div class="all-game">
    <div class="qrcontain" v-show="qrshow">
        <img class="close" src="@/assets/product/close.png" @click="closeQr"/>
        <div id="qrcode"  v-click-out="closeQr">
            <span class="title">{{title}}</span>
            <a class="url" :href="url" target="_blank">下载地址</a>
        </div>
    </div>
    <top-bar></top-bar>
    <div class="contain">
        <div class="first">
            <div class="left">
                <img src="@/assets/game/blockPuzzle.png" class="main-img">
            </div>
            <div class="right">
                <div>
                    <img :src="getImg([blockPuzzleLogo, blockPuzzleLogoTw, blockPuzzleLogoEn])">
                </div>
                <div class="item-tip">
                    {{getLan('be04815e-17b6-43f7-bda4-2f7c76692508')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/peruser.png"/>
                    <span>{{getLan('65003352-fc88-41f8-9508-ee753b2cb247')}}</span>
                </div>
                <div class="descrip">
                    {{getLan('bf7c5067-1954-467a-b11b-5fe441822991')}}
                    <br>
                    {{getLan('8a54e989-e82d-487c-a824-51975bc5a066')}}
                    <br>
                    {{getLan('bf6035bf-2c32-4684-bee9-ae6bc3e2a391')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'blockpuzzle', 0)"/>
                        <img src="@/assets/product/appstore.png" @click="getQR($event, 'blockpuzzle', 1)"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="second">
            <div class="right">
                <div>
                    <img :src="getImg([sudokuLogo, sudokuLogoTw, sudokuLogoEn])"/>
                </div>
                <div class="item-tip">
                    {{getLan('050d0db0-39c3-4598-8894-e6521ab96642')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/peruser.png"/>
                    <span>{{getLan('7b14d5bf-db1e-4983-a362-7f88320ab443')}}</span>
                    <img src="@/assets/product/alluser.png"/>
                    <span>{{getLan('5f46a9fb-493f-4396-a412-d6c40d7dd756')}}</span>
                </div>
                <div class="descrip">
                    {{getLan('c64a6f6d-a302-4f46-bd0e-d2fbdd01ae75')}}
                    <br>
                    {{getLan('a338ba16-40bf-45ff-9eee-ffbbbad03e6f')}}
                    <br>
                    {{getLan('c008e1b0-1c11-410b-bf23-03052f542df7')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'sudoku', 0)"/>
                        <img src="@/assets/product/appstore.png" @click="getQR($event, 'sudoku', 1)"/>
                    </div>
                </div>
            </div>
            <div class="left">
                <img class="main-img" src="@/assets/game/sudoku.png"/>
            </div>
        </div>
        <div class="first">
            <div class="left">
                <img src="@/assets/game/card.png" class="main-img">
            </div>
            <div class="right">
                <div>
                    <img :src="getImg([cardLogo, cardLogoTw, cardLogoEn])">
                </div>
                <div class="item-tip">
                    {{getLan('3e8ca3d5-c5cc-4851-b67c-fbf4e55f5289')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/alluser.png"/>
                    <span>{{getLan('92954d2f-961e-46ff-9f9a-209e322e99c7')}}</span>
                </div>
                <div class="descrip">
                    {{getLan('808b828c-67c0-4edc-b1c0-77fd32aec16e')}}
                    <br>
                    {{getLan('a13eeb7b-d655-472d-bd3b-64473135a117')}}
                    <br>
                    {{getLan('c92b59f3-521e-4594-bda3-234e4f41a1ff')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'card', 0)"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="second">
            <div class="right">
                <div>
                    <img :src="getImg([woodBlockLogo, woodBlockLogoTw, woodBlockLogoEn])"/>
                </div>
                <div class="item-tip">
                    {{getLan('fa44ce56-291f-4a3b-a512-9d087c76f3a8')}}
                </div>
                <div class="main-honor">
                    <img src="@/assets/product/alluser.png"/>
                    <span>{{getLan('e3767d7b-bf3b-4e97-8838-31e961ffbd1e')}}</span>
                </div>
                 <div class="descrip">
                    {{getLan('ae71ad50-3cc9-4d0c-afeb-938301c6a9a2')}}
                    <br>
                    {{getLan('af69bb97-a02a-48da-98b3-d982d44dbd80')}}
                    <br>
                    {{getLan('73de23a5-056c-490b-a939-1da3e4fb0611')}}
                    <div class="sign">
                        <img src="@/assets/product/googleplay.png" @click="getQR($event, 'woodBlock', 0)"/>
                    </div>
                </div>
            </div>
            <div class="left">
                <img class="main-img" src="@/assets/game/woodBlock.png"/>
            </div>
        </div>
        <div class="recommend-game">
            <img src="@/assets/game/easyDrawing.png" />
            <img src="@/assets/game/drum.png" />
            <img src="@/assets/game/guitar.png" />
            <img src="@/assets/game/paint.png" />
        </div>
    </div>
    <bottom-bar></bottom-bar>
  </div>
</template>

<script>
import TopBar from './TopBar'
import BottomBar from './BottomBar'
import QRCode from 'qrcodejs2'

import blockPuzzleLogo from '@/assets/game/blockPuzzleLogo.png'
import blockPuzzleLogoEn from '@/assets/game/blockPuzzleLogoEn.png'
import blockPuzzleLogoTw from '@/assets/game/blockPuzzleLogoTw.png'

import sudokuLogo from '@/assets/game/sudokuLogo.png'
import sudokuLogoEn from '@/assets/game/sudokuLogoEn.png'
import sudokuLogoTw from '@/assets/game/sudokuLogoTw.png'

import cardLogo from '@/assets/game/cardLogo.png'
import cardLogoEn from '@/assets/game/cardLogoEn.png'
import cardLogoTw from '@/assets/game/cardLogoTw.png'

import woodBlockLogo from '@/assets/game/woodBlockLogo.png'
import woodBlockLogoTw from '@/assets/game/woodBlockLogoTw.png'
import woodBlockLogoEn from '@/assets/game/woodBlockLogoEn.png'

const urlInfo = {
    sudoku: ['https://play.google.com/store/apps/details?id=easy.sudoku.puzzle.solver.free','https://itunes.apple.com/app/id1442749804'],
    woodBlock: ['https://play.google.com/store/apps/details?id=block.puzzle.sudoku.free.game.classic.offline'],
    blockpuzzle: ['https://play.google.com/store/apps/details?id=puzzle.blockpuzzle.cube.relax','https://apps.apple.com/app/id1466197423'],
    card: ['https://play.google.com/store/apps/details?id=beetles.puzzle.solitaire']
}

let lockHideQr = false
export default {
  components: {
      TopBar,
      BottomBar
  },
  data() {
      return {
            qrcode: null,
            qrshow: false,
            title: '',
            url: '',
            blockPuzzleLogo,
            blockPuzzleLogoEn,
            blockPuzzleLogoTw,
            sudokuLogo,
            sudokuLogoEn,
            sudokuLogoTw,
            cardLogo,
            cardLogoEn,
            cardLogoTw,
            woodBlockLogo,
            woodBlockLogoTw,
            woodBlockLogoEn
    }
  },
  methods: {
        genQr(url) {
            this.url = url
            if (this.qrcode) {
                this.qrcode.clear()
                this.qrcode.makeCode(url)
                return
            }
            this.qrcode = new QRCode('qrcode', {
                width: 256,
                heigth: 256,
                text: url,
                // colorDark : "#000000",
                // colorLight : "#ffffff",
            })
        },
        moveQr(target) {
            let qrelement = document.querySelector('#qrcode')
            let qcotain = document.querySelector('.qrcontain')
            qcotain.style.top = window.scrollY + 'px'

        },
        getQR(e, type, index) {
            console.log('e:', e)
            console.dir(e.target.offsetLeft)
            this.qrshow = true
            this.moveQr(e.target)
            this.genQr(urlInfo[type][index])
            lockHideQr = true
            this.title = index ? 'iOS' : 'Android'
            setTimeout(() => {
                lockHideQr = false
            }, 1000);
        },
        closeQr() {
            if (lockHideQr) return
            this.qrshow = false
        }
    }
}
</script>

<style scoped>
.qrcontain {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0,0,0,0.7);
    z-index: 888;
}
.close {
    width: 3.19rem;
    height: 3.19rem;
    position: absolute;
    top: 8.74rem;
    right: 3.72rem;
    cursor: pointer;
}
#qrcode {
    position: absolute;
    z-index: 1000;
    left: 50%;
    top: 50%;
    height: 330px;
    width: 256px;
    padding: 0.3rem;
    transform: translate(-50%, -50%);
    background: rgba(255, 255, 255, 1);
    padding: 0 2.41rem 2.41rem 2.41rem;
}
#qrcode .title {
    font-weight: 500;
    margin-left: 3.55rem;
    text-align: center;
    font-size: 14px;
    height: 2.41rem;
}
#qrcode .url {
    font-size: 14px;
    color: #FD9A27;
    text-decoration: none;
}
.contain {
    position: relative;
    padding-top: 5.97rem;
    /* padding-left: 23.98rem; */
    text-align: center;
    transform: translate3d(0,0,0);
    background: linear-gradient(#f7f9fb, #ffffff)
}
.title {
    font-size: 2.09rem;
    font-weight: bold;
    line-height: 3.8rem;
    color: #303030;
}
.first {
    display:flex;
    margin-top: 3.56rem;
    margin-bottom: 6rem;
}
.second {
    display:flex;
    margin-bottom: 6rem;
}

.first .left{
    text-align: right;
    margin-right: 4.29rem;
}
.second .left {
    text-align: left;
}
.second .right {
    min-width: 21rem;
    text-align: right;
    margin-right: 4.29rem;
}
.first .right div:first-child img{
    height: 3.77rem;
    text-align: left;
}
.first .right div:first-child img:first-child {
    height: 2.77rem;
}
.second .right div:first-child img{
    height: 2.77rem;
    text-align: right;
}

.left {
    width: 50%;
    /* display: inline-block; */
    min-width: 21rem;
}
.right {
    width: 50%;
    /* display: inline-block; */
    /* margin-left: 4.29rem;
    margin-right: 4.29rem; */
    /* vertical-align: top; */
    /* line-height: 26.49rem; */
    vertical-align: top;
    height: 26.49rem;
    padding-top: 2.5rem;
    text-align: left;
}
.main-img {
    width: 24.45rem;
    height: 26.49rem;
}
.item-tip {
    font-size: 1.68rem;
    font-weight: 500;
    color: #666;
    line-height: 2.23rem;
    margin-top: 0.99rem;
    margin-bottom: 1.26rem;
}

.main-honor img {
    height: 1.15rem;
}
.main-honor span{
    vertical-align: top;
    font-size: 0.94rem;
    /* line-height: 1.73rem; */
}
.main-honor div {
    display: inline-block;
    margin-left: 1.41rem;
}
.descrip {
    margin-top: 1.57rem;
    font-size: 0.94rem;
    color: #999999;
    line-height: 1.73rem;
}
.sign {
    margin-top: 2.04rem;
}
.sign img {
    position: relative;
    z-index: 700;
    cursor: pointer;
    height: 1.57rem;
}
.awards {
    vertical-align: bottom;
    height: 3.77rem !important;
}

.recommend-game{
    margin-bottom: 6rem;
}
.recommend-game > img {
    width:10.7rem;
    height:10.7rem;
    object-fit: cover;
    margin-left:1.3rem;
    margin-right:1.3rem;
}
</style>


// WEBPACK FOOTER //
// src/components/AllGame.vue